/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Link } from 'react-router-dom';

import { NO_MARGIN_BOTTOM } from '@constants';
import { TextField, RadioField } from '@molecules';
import { Form } from '@organisms';
import { Block, ErrorMessage, Button } from '@atoms';
import ROUTES from '@constants/routes';

import { FORM_FIELD } from './constants';

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};

const LanguageForm = ({ initialValues = {}, error, form, disableFields, languageId, languageCode }) => {
  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <TextField {...FORM_FIELD.LANGUAGE_NAME} disabled={disableFields} />
        <TextField {...FORM_FIELD.LOCALE_NAME} disabled={disableFields} />
        <TextField {...FORM_FIELD.LOCALE_CODE} disabled={disableFields} />
        <RadioField
          {...FORM_FIELD.TEXT_DIRECTION}
          radioStyle={radioStyle}
          disabled={disableFields}
          style={!languageId && NO_MARGIN_BOTTOM}
        />
        {languageId && (
          <Link to={`${ROUTES.VOCABULARY}/${languageCode}`}>
            <Button type="primary">EDIT VOCABULARY</Button>
          </Link>
        )}
      </Block>
    </Form>
  );
};

LanguageForm.useForm = () => Form.useForm(FORM_FIELD);

export default LanguageForm;
